import { useTheme } from 'context/Theme/Theme.context';

export const EditIcon = () => {
    const color = useTheme().textColor;

    return (
        <svg
            width="24.000000"
            height="24.000000"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <clipPath id="clip4355_12942">
                    <rect
                        id="pen"
                        rx="6.000000"
                        width="24.000000"
                        height="24.000000"
                        fill={color}
                        fillOpacity="0"
                    />
                </clipPath>
            </defs>
            <g clipPath="url(#clip4355_12942)">
                <path
                    id="Icon"
                    d="M3.04 20.66C3.21 19.49 3.3 18.9 3.49 18.35C3.66 17.86 3.89 17.4 4.17 16.97C4.5 16.49 4.92 16.07 5.76 15.23L17.41 3.58C18.19 2.8 19.45 2.8 20.23 3.58C21.01 4.37 21.01 5.63 20.23 6.41L8.37 18.27C7.61 19.04 7.23 19.42 6.8 19.72C6.41 19.99 6 20.21 5.56 20.38C5.07 20.58 4.54 20.68 3.48 20.9L3 20.99L3.04 20.66ZM15.5 5.5L18.32 8.32"
                    stroke={color}
                    strokeOpacity="1.000000"
                    strokeWidth="1.000000"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};
